import { toast } from "react-toastify"
import {
    handleApplicationSearchDataSlice,
    handleBulkAssignResponse,
    handleBulkUploadRes,
    handleComplaintModeDataSlice,
    handleComplaintSourceDataSlice,
    handleCreateGrievanceSlice,
    handleCustomerDetailsSearchDataSlice,
    handleDepartmentDataSlice,
    handleDistrictMasterSlice,
    handleDownloadGrievanceDataSlice,
    handleFinalDispositionDataSlice,
    handleGrievanceDataSlice,
    handleGrievanceDetailsDataSlice,
    handleGrievanceDescriptionSearchDataSlice,
    handleGrievanceDocSlice,
    handleGrievanceDocUploadSlice,
    handleGrievanceTypeDataSlice,
    handleLineOfBusinessDataSlice,
    handleLocationDataSlice,
    handlePolicyDetailsSearchDataSlice,
    handleProductDataSlice,
    handleRequestTypeDataSlice,
    handleSeasonDataSlice,
    handleStateMasterSlice,
    handleStatusDataSlice,
    handleStoreDeleteGrievance,
    handleStoreGrievanceFeedbackInfo,
    handleUpdateGrievanceDetailsSlice,
    hasError,
    startLoadingGrievance,
    stopLoadingGrievance,
    handleSeverityDataSlice,
    handleSetBBFailureTickets,
} from "../redux/slices/grievancesSlice"
import { method, paths } from "../services/ServiceConstants"
import ServicesManagerAPICall from "../services/ServicesManagerAPICall"
import { downloadFileInBase64 } from "../utils/FileExport"
import {
    mapGrievanceModeMaster,
    mapGrievanceSourceMaster,
    mapGrievanceTypeMaster,
    mapMasters,
    mapLOBMaster,
    mapRequestTypeMaster,
    mapStatusMaster,
    mapFDMaster,
} from "../utils/MastersMapping"
import { checkNullValue, convertDate, convertWithoutTimezone, formattedDate, timeStampToDate } from "../utils/Util"
import { LINE_OF_BUSINESS, STATUS } from "../utils/Constant"

export const getGrievanceTypeMastersApi = () => {

    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_TYPE,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleGrievanceTypeDataSlice(res));
                }
            }, (err: any) => {

            })
        } catch (error) {
            console.log("error", error)
        }

    }
}

export const statusMastersApi = () => {

    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_STATUS,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleStatusDataSlice(res));
                }
            }, (err: any) => {

            })
        } catch (error) {
            console.log("error", error);
        }
    }
}

export const severityMastersApi = () => {

    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_SEVERITY,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleSeverityDataSlice(res));
                }
            }, (err: any) => {
            })
        } catch (error) {
            console.log("No data displyed", error);
        }
    }
}

export const grievanceSourceMastersApi = () => {

    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_SOURCE,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleComplaintSourceDataSlice(res));
                }
            }, (err: any) => {

            })
        } catch (error) {

        }

    }
}

export const grievanceModeMastersApi = () => {

    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_MODE,
                {},
                false,
                true
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleComplaintModeDataSlice(res));
                }
            }, (err: any) => {

            })
        } catch (error) {

        }

    }
}

export const finalDispositionMastersApi = () => {

    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_FINAL_DISPOSITION,
                {},
                false,
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleFinalDispositionDataSlice(res));
                }
            }, (err: any) => {

            })
        } catch (error) {

        }

    }
}

export const seasonnMastersApi = () => {

    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_SEASON,
                {},
                false,
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleSeasonDataSlice(res));
                }
            }, (err: any) => {

            })
        } catch (error) {

        }

    }
}

export const departmentMastersApi = () => {

    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_DEPARTMENT,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleDepartmentDataSlice(res));
                }
            }, (err: any) => {

            })
        } catch (error) {

        }

    }
}

export const productMastersApi = () => {

    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_PRODUCT,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleProductDataSlice(res));
                }
            }, (err: any) => {

            })
        } catch (error) {

        }

    }
}
export const getProductsByLobApi = (lobId: number) => {
    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                `${paths.API_VERSION}/${Number(lobId)}/products`,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleProductDataSlice(res));
                }
            }, (err: any) => {

            })
        } catch (error) {
            console.log("not working getProductsByLobApi:", error)
        }
    }
}
export const typeOfRequestMastersApi = () => {

    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_REQUEST_TYPE,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleRequestTypeDataSlice(res));
                }
            }, (err: any) => {

            })
        } catch (error) {

        }

    }
}
export const lineOfBusinessMastersApi = () => {

    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_LOB,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleLineOfBusinessDataSlice(res));
                }
            }, (err: any) => {

            })
        } catch (error) {

        }

    }
}

export const grievanceDashboardApi = (selectedFilter: any, offset: any, limit: any, searchTerms: any) => {
    const data = {
        offset: offset,
        limit: limit,
        name: searchTerms?.name ? searchTerms?.name?.trim() : -1,
        mobileno: selectedFilter.mobileNumber && selectedFilter.mobileNumber != 'ALL' ? selectedFilter.mobileNumber?.trim() : -1,
        grievance_id: searchTerms?.grievanceId ? searchTerms?.grievanceId?.trim() : -1,
        policyno: selectedFilter.policyNumber && selectedFilter.policyNumber != 'ALL' ? selectedFilter.policyNumber?.trim() : -1,
        spoc: searchTerms?.spoc ? searchTerms?.spoc?.trim() : -1,
        claimno: searchTerms?.claimId ? searchTerms?.claimId?.trim() : -1,
        referenceno: searchTerms?.referenceId ? searchTerms?.referenceId?.trim() : -1,
        mode_id: typeof selectedFilter?.complaintMode?.value === 'number' ?
            selectedFilter.complaintMode.value : -1,
        status: typeof selectedFilter?.status?.value === 'number' ?
            selectedFilter.status.value : -1,
        department_id: typeof selectedFilter?.department?.value === 'number' ?
            selectedFilter.department.value : -1,
        lineOfBussiness: typeof selectedFilter?.lob?.value === 'number' ?
            selectedFilter.lob.value : -1,
        request_type_id: typeof selectedFilter?.requestType?.value === 'number' ?
            selectedFilter.requestType?.value : -1,
        source_id: typeof selectedFilter?.source?.value === 'number' ?
            selectedFilter.source.value : -1,
        type_id: typeof selectedFilter?.grievanceType?.value === 'number' ?
            selectedFilter.grievanceType.value : -1,
        createdAt: selectedFilter?.createdDate ? formattedDate(selectedFilter?.createdDate) : -1,
        dateOfClosure: selectedFilter?.closureDate ? formattedDate(selectedFilter?.closureDate) : -1,
    }
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_DASHBOARD,
                data,
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    for (let i = 0; i < res.data?.grievanceDashBoardResponse?.length; i++) {
                        let d1 = res.data?.grievanceDashBoardResponse[i]?.createdAt;
                        let [day, month, rest] = d1.split('-');
                        let convertedDate = `${month}-${day}-${rest}`;
                        let date = new Date(convertedDate);
                        date.setTime(date.getTime() + (5 * 60 * 60 * 1000) + (30 * 60 * 1000));
                        let createdDate = convertDate(date);

                        let currDate = new Date();
                        let timeSpent = currDate.getTime() - date.getTime()
                        let daysSpent = Math.floor(timeSpent / (24 * 60 * 60 * 1000));
                        daysSpent = daysSpent < 0 ? 0 : daysSpent;

                        let closureDate
                        if (res.data.grievanceDashBoardResponse[i].dateOfClosure) {
                            let cdate = timeStampToDate(res.data.grievanceDashBoardResponse[i]?.dateOfClosure);
                            closureDate = convertDate(cdate)
                        }

                        date.setDate(date.getDate() + Number(res.data.grievanceDashBoardResponse[i].turnAroundTime));
                        let tAT = convertDate(date);

                        let reopenDate
                        if (res.data.grievanceDashBoardResponse[i].reopenDate) {
                            let rdate = timeStampToDate(res.data.grievanceDashBoardResponse[i]?.reopenDate);
                            reopenDate = convertDate(rdate)
                        }

                        res.data.grievanceDashBoardResponse[i] = { ...res.data.grievanceDashBoardResponse[i], createdDate: createdDate };
                        res.data.grievanceDashBoardResponse[i] = { ...res.data.grievanceDashBoardResponse[i], tat: tAT };
                        res.data.grievanceDashBoardResponse[i] = { ...res.data.grievanceDashBoardResponse[i], daysSpent: daysSpent?.toString() };
                        res.data.grievanceDashBoardResponse[i] = { ...res.data.grievanceDashBoardResponse[i], closureDate: closureDate };
                        res.data.grievanceDashBoardResponse[i] = { ...res.data.grievanceDashBoardResponse[i], reopenDate: reopenDate };
                    }
                    dispatch(handleGrievanceDataSlice(res));
                }
            }, (err: any) => {
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            dispatch(hasError(error));
            dispatch(handleGrievanceDataSlice({}));
        }

    }
}

export const grievanceDownloadReportsApi = (dateFrom: any, dateTo: any, lob: any) => {
    const data = {
        startDate: dateFrom,
        endDate: dateTo,
        lobId: typeof lob?.value === 'number' ? mapLOBMaster(lob.label) : -1,
        flag: 1
    }
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_DOWNLOAD,
                data,
                false
            ).then(async (res: any) => {
                if (res?.statusId == 'OK') {
                    if (res.data.length > 0) {
                        downloadFileInBase64(res.data, 'Grievance_Report.xlsx', 'xlsx')
                    }
                }
                else {
                    toast.info('No Data Found');
                }
                dispatch(stopLoadingGrievance());
            }, (err: any) => {
                dispatch(stopLoadingGrievance());
            })
        } catch (error: any) {
            dispatch(hasError(error));
        }

    }
}

export const grievanceDetailsApi = (grievance_id: any) => {
    const data = {
        grievanceId: grievance_id
    }
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_INFO,
                data,
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleGrievanceDetailsDataSlice(res));
                }
            }, (err: any) => {
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            dispatch(hasError(error));
        }

    }
}

export const grievanceDetailsUpdateApi = (body: any) => {
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.PUT,
                paths.GRIEVANCE_UPDATE,
                body,
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    if (res.statusId === 'OK') {
                        dispatch(handleUpdateGrievanceDetailsSlice({ res: res, moveToFreshWorks: body.moveToFreshWorks, requestType: body.typeOfRequest }));
                    }
                    else {
                        dispatch(handleUpdateGrievanceDetailsSlice({ res: res, message: 'failed' }));
                        dispatch(stopLoadingGrievance());
                    }
                }
                else {
                    dispatch(handleUpdateGrievanceDetailsSlice({ res: res, message: 'failed' }));
                    dispatch(stopLoadingGrievance());
                }
            }, (err: any) => {
                dispatch(handleUpdateGrievanceDetailsSlice({ res: err?.response?.data, message: 'failed' }));
                dispatch(stopLoadingGrievance());
            })
        } catch (error: any) {
            dispatch(hasError(error));
            dispatch(handleUpdateGrievanceDetailsSlice({ res: error?.response?.data, message: 'failed' }));
        }

    }
}

export const createGrievanceApi = (data: any) => {
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.POST,
                paths.GRIEVANCE_CREATE,
                data,
                false
            ).then(async (res: any) => {
                const bbMsg = res?.bimaBharosaStatus || "";

                if (res?.statusId === 'OK') {
                    dispatch(handleCreateGrievanceSlice(res));
                    toast.success(<>Grievance Created Successfully.<br /> {bbMsg}</>);

                }
                else if (res.data) {
                    dispatch(stopLoadingGrievance());
                    toast(<>  {res.data}<br />  {bbMsg} </>);
                }
                else {
                    dispatch(stopLoadingGrievance());
                    toast.error(<> Failed to Create the Grievance.<br /> {bbMsg} </>);
                }
            }, (err: any) => {
                dispatch(stopLoadingGrievance());

                const bbMsg = err?.response?.data?.bimaBharosaStatus || "";

                toast.error(<> {err?.data || "Error occurred"}<br /> {bbMsg}  </>
                );
            })
        } catch (error: any) {
            dispatch(hasError(error));

            const bbMsg = error?.response?.data?.bimaBharosaStatus || "Ticket movement to Bhima Bharosa failed.";
            toast.error(<> Failed to Create the Grievance.<br /> + {bbMsg} </>);
        }

    }
}

export const getDocsApi = (grievanceId: any) => {
    const data = {
        grievanceId: grievanceId
    }
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_DOC,
                data,
                false,
                true
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleGrievanceDocSlice(res));
                }
            }, (err: any) => {
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            dispatch(hasError(error));
        }

    }
}

export const docUploadApi = (grievanceId: any, image: any, referenceId?: string) => {
    const data = {
        grievanceId: grievanceId,
        docs: [
            {
                documentId: '',
                docName: image?.imageName,
                docReferenceId: referenceId ?? '',
                metaInfo: {
                    docType: image?.imageType
                },
                content: image?.imageBase64,

            }
        ]
    }
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.POST,
                paths.GRIEVANCE_DOC_UPLOAD,
                data,
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleGrievanceDocUploadSlice(res));
                    if (res?.response != 'updated Successfully') {
                        if (res?.response) {
                            toast(res.response)
                        }
                        else if (res?.message === 'JSON parse error: String length (20051112) exceeds the maximum length (20000000)') {
                            toast.error('File size exceeds the 15MB');
                        }
                        else if (res?.message) {
                            toast.error(res?.message)
                        }
                        else {
                            toast.error('Unable to process the file.')
                        }
                    }
                }
                else {
                    toast.error('Unable to process the file.')
                }
            }, (err: any) => {
                toast.error('Unable to process the file.')
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            toast.error('Unable to process the file.')
            dispatch(hasError(error));
        }

    }
}

export const stateMasterApi = () => {
    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.STATE_MASTER,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleStateMasterSlice(res));
                }
            }, (err: any) => {

            })
        } catch (error) {

        }

    }
}

export const getDistrictsApi = (stateId: any) => {
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.STATE_MASTER + `/${stateId}` + paths.DISTRICT_MASTER,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleDistrictMasterSlice(res));
                }
            }, (err: any) => {
                dispatch(handleDistrictMasterSlice(''));
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            dispatch(handleDistrictMasterSlice(''));
            dispatch(hasError(error));
        }

    }
}

export const getLocationDataApi = (pincode: string) => {
    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                `/v1.1/${pincode}` + paths.LOCATION_DETAILS,
                {},
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    if (res.statusId === 'OK') {
                        dispatch(handleLocationDataSlice(res));
                    }
                    else {
                        toast.error('Pincode not found');
                    }
                }
            }, (err: any) => {
                toast.error('Pincode not found');
            })
        } catch (error) {
            toast.error('Pincode not found');
        }

    }
}

export const customerDetailsSearchApi = (data: any, searchValue: string, callWithMobile?: boolean, callWithPolicy?: boolean) => {
    const body = {
        productId: mapLOBMaster(data.lineOfBusiness),
        searchType: data?.searchPolicy || data?.searchPMFBYPolicy || data?.searchRWBCISPolicy ? 2 : 1,
        searchValue: searchValue
    }
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.CUSTOMER_SEARCH + '/',
                body,
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    if (res.statusId !== 200) {
                        if (callWithPolicy && !callWithMobile) {
                            toast.warn('No Results found, Kindly search with the mobile no.');
                        } else if (callWithMobile && !callWithPolicy) {
                            toast.warn('No Results found, Kindly search with the policy no.');
                        } else {
                            toast.error('No Results found');
                        }
                    }
                    dispatch(handleCustomerDetailsSearchDataSlice(res));
                }
            }, (err: any) => {
                toast.error('Unable to retrieve data. Please try again later');
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            toast.error('Unable to retrieve data. Please try again later');
            dispatch(hasError(error));
        }

    }
}

export const applicationDetailsSearchApi = (data: any, searchValue: string, callWithApplication: boolean, callWithPMFBYPolicy: boolean) => {
    const body = {
        productId: mapLOBMaster(data.lineOfBusiness),
        searchType: data?.searchPolicy || data?.searchPMFBYPolicy || data?.searchRWBCISPolicy ? 2 : 1,
        searchValue: searchValue
    }
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.CUSTOMER_SEARCH + '/',
                body,
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    if (res.statusId !== 200) {
                        if (callWithApplication && !callWithPMFBYPolicy) {
                            toast.warn('No Results found, Kindly search with the policy no.');
                        } else if (callWithPMFBYPolicy && !callWithApplication) {
                            toast.warn('No Results found, Kindly search with the application no.');
                        } else {
                            toast.error('No Results found');
                        }
                    }
                    dispatch(handleApplicationSearchDataSlice(res));
                }
            }, (err: any) => {
                toast.error('Unable to retrieve data. Please try again later');
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            toast.error('Unable to retrieve data. Please try again later');
            dispatch(hasError(error));
        }

    }
}

export const policyDetailsSearchApi = (data: any, searchValue: string, grievanceType: string, selectedApplication: any) => {
    let searchId;
    if (mapLOBMaster(data?.lineOfBusiness) == LINE_OF_BUSINESS.CROP_RETAIL) {
        if (data?.searchPolicy) { searchId = 2 }
        else if (data?.searchMobile) {
            if (selectedApplication?.applicationId?.length > 0) { searchId = 2 }
            else { searchId = 1 }
        }
    }

    else if (mapLOBMaster(data?.lineOfBusiness) == LINE_OF_BUSINESS.HEALTH) {
        if (data?.searchHealthPolicy) {
            searchId = 2;
        }
        else if (data?.searchHealthMobile) {
            if (selectedApplication?.policyNo?.length > 0) {
                searchId = 2;
            } else {
                searchId = 1;
            }
        }
    }

    else if (mapLOBMaster(data?.lineOfBusiness) == LINE_OF_BUSINESS.PMFBY || mapLOBMaster(data?.lineOfBusiness) == LINE_OF_BUSINESS.RWBCIS) {
        searchId = 2
    }
    if (!searchId) {
        searchId = 1;
    }
    const body = {
        typeId: mapGrievanceTypeMaster(grievanceType),
        productId: mapLOBMaster(data.lineOfBusiness),
        searchId: searchId,
        searchValue: searchValue
    }
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.POLICY_SEARCH + '/',
                body,
                false
            ).then(async (res: any) => {
                if (res !== null) {
                    if (mapLOBMaster(data?.lineOfBusiness) == LINE_OF_BUSINESS.HEALTH) {
                        dispatch(handlePolicyDetailsSearchDataSlice({
                            ...res,
                            data: res.data?.map((item: any) => ({
                                ...item,
                                memberId: selectedApplication?.memberId
                            }))
                        }));
                    } else {
                        dispatch(handlePolicyDetailsSearchDataSlice(res));
                    }
                }
            }, (err: any) => {
                toast.error('Unable to retrieve data. Please try again later');
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            toast.error('Unable to retrieve data. Please try again later');
            dispatch(hasError(error));
        }

    }
}

export const getGrievanceDescriptionsApi = (complaintTypeId?: any) => { //get a list of complaint descriptions based on the selected grievance type
    return async (dispatch: any) => {
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.GRIEVANCE_DESCRIPTION + (complaintTypeId ? `?complaintTypeId=${complaintTypeId}` : ''),
                {},
                false,
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleGrievanceDescriptionSearchDataSlice(res));
                }
            }, (err: any) => {
                toast.error('Unable to retrieve data. Please try again later');
            })
        } catch (error) {
            toast.error('Unable to retrieve data. Please try again later');
        }
    }
}

export const deleteGrievanceApi = (grievanceId: string) => {
    const body = {
        grievanceId: grievanceId,
        flag: 2
    }
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.PUT,
                paths.DELETE_GRIEVANCE,
                body,
                false
            ).then(async (res: any) => {
                if (res !== null && res.data == 'deleted') {
                    dispatch(handleStoreDeleteGrievance(res));
                }
                else {
                    toast.error('Unable to delete the grievance');
                }
            }, (err: any) => {
                toast.error('Unable to delete the grievance');
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            toast.error('Unable to delete the grievance');
            dispatch(hasError(error));
        }

    }
}

export const bulkAssignAPi = (data: any) => {
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.PUT,
                paths.BULK_ASSIGN,
                data,
                false
            ).then(async (res: any) => {
                if (res?.statusId == 200) {
                    dispatch(handleBulkAssignResponse(res));
                }
                else {
                    toast.error('Bulk Assignment Failed');
                    dispatch(stopLoadingGrievance());
                }
            }, (err: any) => {
                toast.error('Bulk Assignment Failed');
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            toast.error('Bulk Assignment Failed');
            dispatch(hasError(error));
        }

    }
}

export const bulkUploadApi = (uploadedFiles: any[], userName: string, uploadType: any) => {
    const headers = {
        'Accept': '*/*',
        'Content-Type': 'multipart/form-data'
    }

    const formData: FormData = new FormData();

    uploadedFiles.map((each: any) => {
        formData.append('fileList', each)
    })

    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.POST,
                (uploadType === 1 ? paths.BULK_UPLOAD : uploadType === 2 ? paths.BULK_UPLOAD_CPGRAM : paths.BULK_UPLOAD_KRPH) + `?userName=${userName}`,
                formData,
                false,
                false,
                headers
            ).then(async (res: any) => {
                if (res !== null) {
                    dispatch(handleBulkUploadRes(res));
                }
                else {
                    dispatch(handleBulkUploadRes({}));
                    dispatch(stopLoadingGrievance());
                }
            }, (err: any) => {
                dispatch(handleBulkUploadRes({}));
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            dispatch(handleBulkUploadRes({}));
            dispatch(hasError(error));
        }

    }
}

export const downloadBulkErrorLogs = (log: any, userName: string, uploadType: number) => {
    let data = {
        fileName: log?.fileName,
        fileId: log?.fileId,
        uploadedBy: userName,
    }
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                (uploadType === 1 ? paths.DOWNLOAD_LOGS : uploadType === 2 ? paths.DOWNLOAD_LOGS_CPGRAM : paths.DOWNLOAD_LOGS_KRPH),
                data,
                false,
                false,
            ).then(async (res: any) => {
                if (res?.base64?.length > 0) {
                    downloadFileInBase64(res?.base64, res?.fileName, res?.fileType);
                }
                else {
                    toast.error('Unable to fetch data');
                }
                dispatch(stopLoadingGrievance());
            }, (err: any) => {
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            dispatch(hasError(error));
        }

    }
}

export const downloadMsgFile = (grievanceId: string, fileName: string) => {
    const data = {
        fileType: fileName?.split('.')[1],
        grievanceId: grievanceId,
        fileName: fileName
    }
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.DOWNLOAD_ATTACHMENTS,
                data,
                false,
                true
            ).then(async (res: any) => {
                if (res !== null) {
                    downloadFileInBase64(res.base64, res?.fileName, fileName?.split('.')[1])
                    dispatch(stopLoadingGrievance())
                }
            }, (err: any) => {
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            dispatch(hasError(error));
        }

    }
}

export const getFeedbackDetailsById = (grievanceId: string) => {
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            await ServicesManagerAPICall.request(
                method.GET,
                `${paths.GET_FEEDBACK}?grievanceId=${grievanceId}`,
                {},
                false,
                false
            ).then(async (res: any) => {
                if (res?.statusId === 200) {
                    dispatch(handleStoreGrievanceFeedbackInfo(res));
                }
                else {
                    dispatch(stopLoadingGrievance());
                }
            }, (err: any) => {
                dispatch(stopLoadingGrievance());
            })
        } catch (error) {
            dispatch(hasError(error));
        }

    }
}

export const docsUploadApi = (
    grievanceId: any,
    images: any[],
    referenceId: string = '',
    isFRRDocList: boolean = false,
    onSuccess?: () => void
) => {
    const data = {
        grievanceId,
        referenceId,
        isFRRDocList,
        docs: images.map((image: any) => ({
            documentId: '',
            docName: image?.imageName,
            docReferenceId: referenceId ?? '',
            metaInfo: { docType: image?.imageType },
            content: image?.imageBase64,
        })),
    };

    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {
            const res: any = await ServicesManagerAPICall.request(
                method.POST,
                paths.GRIEVANCE_DOC_UPLOADS,
                data,
                false
            );

            if (res !== null) {
                dispatch(handleGrievanceDocUploadSlice(res));

                if (res?.response === 'updated Successfully') {
                    onSuccess?.();
                } else {
                    if (res?.response) {
                        toast(res.response);
                    } else if (
                        res?.message ===
                        'JSON parse error: String length (20051112) exceeds the maximum length (20000000)'
                    ) {
                        toast.error('File size exceeds the 15MB');
                    } else if (res?.message) {
                        toast.error(res.message);
                    } else {
                        toast.error('Unable to process the file.');
                    }
                }
            } else {
                toast.error('Unable to process the file.');
            }
        } catch (error) {
            toast.error('Unable to process the file.');
            dispatch(hasError(error));
        } finally {
            dispatch(stopLoadingGrievance());
        }
    };
};

export const getBBFailureTicketsApi = (grievanceId: string = '', offset: any, limit: any, start?: string, end?: string) => {
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());
        try {

            const params: any = { grievanceId, offset, limit };

            if (start) params.startDate = start;
            if (end) params.endDate = end;

            await ServicesManagerAPICall.request(
                method.GET,
                paths.BB_FAILURE_TICKETS,
                params,
                false
            ).then((res: any) => {
                if (res !== null) {
                    dispatch(handleSetBBFailureTickets({
                        ...res,
                        data: Array.isArray(res?.data) ? res.data : [],
                        count: Array.isArray(res?.data) ? res?.count : 0
                    }));
                }
            }).catch(() => {
                toast.error('Failed to fetch tickets');
            });

        } catch (error) {
            console.log("error", error);

        } finally {
            dispatch(stopLoadingGrievance());
        }
    }
};

export const getBBFlrTcktExcelApi = (start: string, end: string) => {
    return async (dispatch: any) => {
        dispatch(startLoadingGrievance());

        try {
            await ServicesManagerAPICall.request(
                method.GET,
                paths.BB_F_T_EXCEL,
                {
                    startDate: start,
                    endDate: end
                },
                false
            ).then((res: any) => {
                if (res?.data && res.data.length > 0) {
                    downloadFileInBase64(res.data, 'BB_Failure_Tickets.xlsx', 'xlsx');
                } else {
                    toast.info('No Data Found');
                }
            }).catch(() => {
                toast.error('Download failed');
            });

        } catch (error) {
            console.log("error", error);
        } finally {
            dispatch(stopLoadingGrievance());
        }
    }
};


